(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["first-visit-promo"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('FirstVisitPromo');
    if (!dialog) return;

    const storageKey = 'narmer_welcome_offer_seen_v2';
    const closeButton = dialog.querySelector('[data-first-visit-close]');
    const copyButton = dialog.querySelector('[data-first-visit-copy]');
    const isDesignMode = Boolean(window.Shopify && Shopify.designMode);

    const markSeen = () => {
      if (!isDesignMode) localStorage.setItem(storageKey, '1');
    };

    const closeDialog = () => {
      markSeen();
      dialog.close();
    };

    if (closeButton) closeButton.addEventListener('click', closeDialog);

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    dialog.addEventListener('cancel', markSeen);

    if (copyButton) {
      copyButton.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText('WELCOME50');
          copyButton.textContent = copyButton.dataset.copiedLabel;
          markSeen();
        } catch (error) {
          copyButton.textContent = 'WELCOME50';
        }
      });
    }

    const alreadySeen = localStorage.getItem(storageKey) === '1';
    if (isDesignMode || !alreadySeen) {
      window.setTimeout(() => dialog.showModal(), isDesignMode ? 300 : 3000);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
